import {useFormContext} from "react-hook-form";

export function useFormErrors() {
  const {formState: {errors}} = useFormContext();
  const hasErrors = errors && Object.keys(errors).length > 0;

  return {errors, hasErrors};
}
